module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p15"
    }
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("God bless the thoughtful islands")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Where never warrants come;")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("God bless the just Republics")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("That give a man a home . . .")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—RUDYARD KIPLING,")]), _vm._v(" “The Broken Men”")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("Come, my friends,")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("’Tis not too late to seek a newer world.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Push off, and sitting well in order smite")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("The sounding furrows, for my purpose holds")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("To sail beyond the sunset, and the baths")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Of all the western stars, until I die.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("It may be that the gulfs will wash us down;")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("It may be we shall touch the Happy Isles . . .")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—TENNYSON,")]), _vm._v(" “Ulysses”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024e2e66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front04.vue
// module id = 69
// module chunks = 0